import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Stylish Plants · Your Green Companion</p>
        <h1>Transform Your Space with Stylish Plants</h1>
        <p className="lede">
          Discover a curated selection of beautiful plants that elevate your home and office. 
          Explore our collection to find the perfect greenery that suits your style and space.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_blank">
            Shop Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Curated Selection</h2>
          <p>
            Browse our handpicked variety of plants, from low-maintenance succulents to vibrant tropicals, 
            perfect for any environment.
          </p>
        </article>
        <article>
          <h2>Expert Guidance</h2>
          <p>
            Our team of plant enthusiasts is here to help you choose the right plants and provide care tips 
            to keep them thriving.
          </p>
        </article>
        <article>
          <h2>Community Connection</h2>
          <p>
            Join our community of plant lovers! Share your journey, get inspired, and connect with others 
            who share your passion for greenery.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;